import * as React from 'react';

import { InjectedTranslateProps, translate } from 'react-i18next';
import { withExperiments, InjectedExperimentsProps } from '@wix/wix-experiments-react';
import { Input } from 'wix-style-react';
import Search from 'wix-ui-icons-common/Search';
import * as s from './TeamMembersList.scss';
import { MembersTableState } from '../types';

interface IProps extends InjectedTranslateProps, InjectedExperimentsProps {
  membersTable: MembersTableState;

  onNamesAndEmailsFilterChanged(e): void;
}

const TeamMembersListNamesAndEmailsFilter: React.FC<IProps> = ({ t, experiments,  membersTable, onNamesAndEmailsFilterChanged }) => {

  if (!experiments.enabled('specs.ident.TableNamesAndEmailsFilter')) {
    return null;
  }

  return (<Input
    value={membersTable.filters.namesAndEmails}
    className={s.namesAndEmailsFilter}
    placeholder={t('teamDetails.actions.NamesAndEmailsFilter.placeholder')}
    onChange={onNamesAndEmailsFilterChanged}
    roundInput
    prefix={
      <Input.IconAffix>
        <Search />
      </Input.IconAffix>
    }
  /> );
};

export default withExperiments(translate()(TeamMembersListNamesAndEmailsFilter));
